import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartData,
  ChartDataset,
  ChartOptions,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

export function HorizontalBarChart({
  data,
  options,
}: {
  data: ChartData<"bar", ChartDataset<"bar">, string>;
  options?: ChartOptions<"bar">;
}) {
  return <Bar data={data} options={{ ...options, indexAxis: "y" }} />;
}
